import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import "./UnpaidLicenseTable.css"

export default function ({ data }: any) {
    return (<>
        <TableContainer>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Nom</TableCell>
                        <TableCell>Prenom</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Telephone</TableCell>
                        <TableCell>Type</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row: any, index: number) => {
                        return (<TableRow key={index}>
                            <TableCell>{row['name']}</TableCell>
                            <TableCell>{row['firstname']}</TableCell>
                            <TableCell>{row['mail']}</TableCell>
                            <TableCell>{row['tel']}</TableCell>
                            <TableCell>{row['type']}</TableCell>
                        </TableRow>)
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    </>)
}